import { render, staticRenderFns } from "./BrigEngItem.vue?vue&type=template&id=4768cbd2&scoped=true&"
import script from "./BrigEngItem.vue?vue&type=script&lang=js&"
export * from "./BrigEngItem.vue?vue&type=script&lang=js&"
import style0 from "./BrigEngItem.vue?vue&type=style&index=0&id=4768cbd2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4768cbd2",
  null
  
)

export default component.exports